export const MAINMAP_MAP_MENUBAR_CONSTANT = {
  setProjectName: 'LI/MAINMAP/MENUBAR/set-project-name',

  RESET_STATUS: 'LI/MAINMAP/MENUBAR/reset-status',
  RESET_ALL: 'LI/MAINMAP/MENUBAR/reset-all',

  PROJECT_GET: 'LI/MAINMAP/MENUBAR/project-get',
};
